<app-deprecated-confirmation-dialog
    #deletePolicyModal
    header="time-off-v3.deleteTimeOffPolicy"
    label="time-off-v3.delete"
    useNgContent="true"
    [negative]="true"
>
    <p>{{ 'time-off-v3.areYouSureYouWantToDeleteThisTimeOffPolicy' | translate }}</p>
    <p>{{ 'time-off-v3.thisWillImmediatelyUnassignAllEmployeesFromThisPolicyEffectiveImmediately' | translate }}</p>
    <p>{{ 'time-off-v3.ifYouPutTheEmployeesBackOntoA' | translate }}</p>
</app-deprecated-confirmation-dialog>

<app-deprecated-modal-form
    [stubby]="true"
    headerText="time-off-v3.reassignEmployees"
    [form]="policyReassignForm"
    #policyReassignDialog
    (save)="onReassignPolicy()"
>
    <app-reassign-policy-form #policyReassignForm></app-reassign-policy-form>
</app-deprecated-modal-form>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        [title]="timeOffPolicy.name"
        [menuService]="menuService"
        [back]="true"
        backRoute="/time-off/v3/types-and-policies"
        [contextMenu]="true"
        contextMenuType="material"
    >
        <button mat-menu-item (click)="onCopyTimeOffPolicy()">{{ 'time-off-v3.editPolicy.copy' | translate }}</button>
        <button mat-menu-item (click)="onDeletePolicy()">{{ 'time-off-v3.delete' | translate }}</button>
        <button mat-menu-item *ngIf="canReassign && !!timeOffPolicy.employeeCount" (click)="onReassignTimeOffPolicy()">
            {{ 'time-off-v3.editPolicy.reassign' | translate }}
        </button>
    </app-header>

    <app-basic-information-details-card
        [editMode]="true"
        [timeOffPolicy]="timeOffPolicy"
    ></app-basic-information-details-card>
    <app-accrual-schedule-details-card
        [editMode]="true"
        [timeOffPolicy]="timeOffPolicy"
    ></app-accrual-schedule-details-card>
    <app-request-rules-details-card
        [timeOffRequestRule]="timeOffRequestRule"
        [unitOfTime]="unitOfTime"
        [editMode]="true"
    ></app-request-rules-details-card>
</div>
